var exports = {
  "kL": "x234b8571--65aa53--container",
  "uW": "x234b8571--65aa53--section",
  "FR": "x234b8571--65aa53--button-container",
};

module.exports = exports;
